import React, { useState, useEffect } from 'react';
import { ThemeContext, themes } from './ThemeContext';

export default function ThemeContextWrapper(props) {
  const preferred_theme = localStorage.getItem("preferred_theme");
  const [theme, setTheme] = useState(preferred_theme ? preferred_theme : 'dark-mode');
  localStorage.setItem("preferred_theme", theme);

  function changeTheme(theme) {
    setTheme(theme);
  }

  useEffect(() => {
    switch (theme) {
      case themes.light:
        document.body.classList.add('light-mode');
        document.body.classList.remove('dark-mode');
        break;
      case themes.dark:
        document.body.classList.add('dark-mode');
        break;
      default:
        document.body.classList.add('dark-mode');
        break;
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme: theme, changeTheme: changeTheme }}>
      {props.children}
    </ThemeContext.Provider>
  );
}